import React from "react";
import { Transformation } from "../../../../types/functions";
import Resources from "../../../../types/Resources";
import { Modal } from "react-bootstrap";
import LabelCheckbox from "../../../Common/LabelCheckbox";
import HotWorkCategoryOneOptionsFormState from "../../../../types/forms/Permits/EnergyHarbourPermit/HotWorkCategoryOneOptionsFormState";
import HotWorkCategoryOneOptions from "../../../../types/permits/EnergyHarbourPermit/HotWorkCategoryOneOptions";
import WarningAlert from "../../../Common/WarningAlert";

type HotWorkCategoryOneOptionsModalProps = {
    formState: HotWorkCategoryOneOptionsFormState;
    onChange: (fn: Transformation<HotWorkCategoryOneOptionsFormState>) => void;
    resources: Resources;
    show: boolean;
    onHide: () => void;
    canManageContent: boolean;
};

function HotWorkCategoryOneOptionsModal({
    formState,
    resources,
    onChange,
    show,
    onHide,
    canManageContent
}: HotWorkCategoryOneOptionsModalProps) {
    function changeHandler(key: keyof HotWorkCategoryOneOptions, value: any) {
        onChange((prevValue) => ({
            ...prevValue,
            [key]: { ...prevValue[key], value }
        }));
    }

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <h1 className="h5">{resources.get("HotWorkCategoryOne")}</h1>
            </Modal.Header>
            <Modal.Body>
                <WarningAlert>
                    {resources.get("ToolsRequireHotWorkCertificate")}
                </WarningAlert>
                <ul className="list-unstyled">
                    <li className="m-2">
                        <LabelCheckbox
                            checked={formState.angleGrinder.value}
                            id="hot-work-category-one-options__angle-grinder"
                            label={resources.get("AngleGrinder")}
                            onChange={(checked) => changeHandler("angleGrinder", checked)}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <LabelCheckbox
                            checked={formState.cuttingTorch.value}
                            id="hot-work-category-one-options__cutting-torch"
                            label={resources.get("CuttingTorch")}
                            onChange={(checked) => changeHandler("cuttingTorch", checked)}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <LabelCheckbox
                            checked={formState.welding.value}
                            id="hot-work-category-one-options__welding"
                            label={resources.get("Welding")}
                            onChange={(checked) => changeHandler("welding", checked)}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <LabelCheckbox
                            checked={formState.hotAirGun.value}
                            id="hot-work-category-one-options__hot-air-gun"
                            label={resources.get("HotAirGun")}
                            onChange={(checked) => changeHandler("hotAirGun", checked)}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <LabelCheckbox
                            checked={formState.gasBurner.value}
                            id="hot-work-category-one-options__gas-burner"
                            label={resources.get("GasBurner")}
                            onChange={(checked) => changeHandler("gasBurner", checked)}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <LabelCheckbox
                            checked={formState.openFlameSoldering.value}
                            id="hot-work-category-one-options__open-flame-soldering"
                            label={resources.get("OpenFlameSoldering")}
                            onChange={(checked) => changeHandler("openFlameSoldering", checked)}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2 d-flex align-items-center m-2">
                        <label className="form-label me-1" htmlFor="hot-work-category-one-options__other me-1">
                            {resources.get("Other")}
                        </label>
                        <input
                            type="text"
                            className={`form-control ${!canManageContent ? "read-only-input" : ""}`}
                            id="hot-work-category-one-options__other"
                            value={formState.other.value ?? ""}
                            onChange={(e) => changeHandler("other", e.target.value)}
                            readOnly={!canManageContent}
                        />
                    </li>
                </ul>
            </Modal.Body>
        </Modal>
    );
}

export default HotWorkCategoryOneOptionsModal;
